import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useMemo as d } from "react";
import { isMobile as p } from "../../../constants/index.js";
import { formatedQty as h, formatBrazilianPrice as u } from "../../../utils/changerOrderModal.js";
const P = ({ selectedItem: n }) => {
  const {
    imageUrl: t,
    name: i,
    quantity: a,
    sellingPrice: o,
    measurementUnit: s,
    unitMultiplier: l
  } = n || {}, c = d(() => p ? 48 : 80, []), m = t == null ? void 0 : t.replace("-55-55", "-80-80");
  return /* @__PURE__ */ r("section", { className: "change-order-pre-content", children: [
    /* @__PURE__ */ e(
      "img",
      {
        height: c,
        width: c,
        style: { objectFit: "contain", width: "20%" },
        src: m,
        alt: i,
        className: "change-order-pre-content-img"
      }
    ),
    /* @__PURE__ */ r("div", { className: "change-order-pre-content-infos", children: [
      /* @__PURE__ */ e("h3", { className: "product-name", children: i }),
      /* @__PURE__ */ r("div", { className: "product-details", children: [
        /* @__PURE__ */ e("p", { className: "quantity", children: h(
          s || "",
          l || 0,
          a || 0
        ) }),
        /* @__PURE__ */ e("p", { className: "sellingPrice", children: u(o || 0) })
      ] })
    ] })
  ] });
};
export {
  P as ProductSelected
};
